/* Shopify'nin kendi panelini yeniden açar; onay durumuna kendiliğinden dokunmaz. */
(function () {
  // Shopify önizleme çubuğu tarayıcının üst katmanında: z-index ile aşılamaz.
  // Gerçek yüksekliğini ayır; çubuk kapanır/daralırsa boşluk da güncellensin.
  var bar;
  var resizeObserver = new ResizeObserver(updateInset);
  var barObserver = new MutationObserver(updateInset);
  function updateInset() {
    var height = 0;
    if (bar && bar.isConnected) {
      var rect = bar.getBoundingClientRect();
      var style = getComputedStyle(bar);
      if (style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0) {
        height = Math.max(0, window.innerHeight - rect.top);
      }
    }
    document.documentElement.style.setProperty('--devin-preview-bar-height', Math.ceil(height) + 'px');
  }
  function findBar() {
    var next = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    if (next === bar) return;
    resizeObserver.disconnect();
    barObserver.disconnect();
    bar = next;
    if (bar) {
      resizeObserver.observe(bar);
      barObserver.observe(bar, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    updateInset();
  }
  new MutationObserver(findBar).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', updateInset, { passive: true });
  findBar();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cerez-tercihleri]');
    if (!button) return;
    var error = button.parentElement.querySelector('[data-cerez-hata]');
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      if (error) error.hidden = true;
      try {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(function () {
          if (error) error.hidden = false;
        });
      } catch (_) {
        if (error) error.hidden = false;
      }
    } else if (error) error.hidden = false;
  });
})();
